<template>
  <div>
    <div id="subscriptionDetail" class="card">
      <div class="title-box mb-4">
        <div class="sub-title">{{ $t('propTrade.createAccount.subscriptionDetail.title') }}</div>
        <p class="narrative">{{ $t('propTrade.createAccount.subscriptionDetail.desc') }}</p>
      </div>
      <el-form class="form-box" :model="form" :rules="formRules" ref="form">
        <h5 class="sub-title">{{ $t('propTrade.createAccount.subscriptionDetail.paymentChannels') }}</h5>
        <div class="payment-method">
          <el-form-item prop="paymentMethod">
            <div class="payment-method-radio-box">
              <div class="payment-method-item" v-for="item in calPaymentMethodList" :key="item.key">
                <el-radio-group
                  v-model="form.paymentMethod"
                  @input="setPaymentDetailDefault"
                  data-testid="paymentMethod"
                >
                  <PaymentMethodRadioButton :name="item.name" :value="item.key" />
                </el-radio-group>
              </div>
            </div>
          </el-form-item>
        </div>
        <div
          class="payment-method-group"
          v-if="
            form.paymentMethod === 'crypto' || form.paymentMethod === 'ewallet' || form.paymentMethod === 'thailandqr'
          "
        >
          <!-- <h5 class="sub-title">{{ $t('propTrade.createAccount.subscriptionDetail.select') }}</h5> -->
          <el-form-item prop="crypto" v-if="form.paymentMethod === 'crypto'">
            <div class="payment-radio">
              <el-radio-group v-model="form.crypto">
                <div
                  v-for="(payment, index) in cryptoList"
                  :key="`ptCrypto${index}`"
                  @click="changePaymentDetail(payment)"
                >
                  <el-radio :label="getPaymentName(payment)">{{ getPaymentName(payment) }}</el-radio>
                </div>
              </el-radio-group>
            </div>
          </el-form-item>
          <el-form-item prop="ewallet" v-if="form.paymentMethod === 'ewallet'">
            <div class="payment-radio">
              <el-radio-group v-model="form.ewallet">
                <div
                  v-for="(payment, index) in ewalletList"
                  :key="`ptEwallet${index}`"
                  @click="changePaymentDetail(payment)"
                >
                  <el-radio :label="getPaymentName(payment)">{{ getPaymentName(payment) }}</el-radio>
                </div>
              </el-radio-group>
            </div>
          </el-form-item>
          <el-form-item prop="thailandqr" v-if="form.paymentMethod === 'thailandqr'">
            <div class="payment-radio">
              <el-radio-group v-model="form.thailandqr">
                <div
                  v-for="(payment, index) in thailandqrList"
                  :key="`ptlbt${index}`"
                  @click="changePaymentDetail(payment)"
                >
                  <el-radio :label="getPaymentName(payment)">{{ getPaymentName(payment) }}</el-radio>
                </div>
              </el-radio-group>
            </div>
            <div :class="['payment_desc', isMobile ? 'payment_desc_start' : '']">
              <img src="@/assets/images/propTrade/info.png" />
              <div class="payment_text">
                <p>{{ $t('deposit.method.inst1', { number: '1' }) }}</p>
                <p>{{ $t('deposit.method.inst2', { number: '2', country: '' }) }}</p>
                <p>{{ $t('deposit.method.inst3', { number: '3' }) }}</p>
                <p>{{ $t('deposit.method.inst6', { number: '4' }) }}</p>
              </div>
            </div>
          </el-form-item>
        </div>
        <div class="divide">
          <hr />
        </div>
        <div
          class="payment-detail-box"
          v-if="chooseAccountData && chooseAccountData.form && chooseAccountData.currentSetting"
        >
          <div class="grey-card">
            <h5 class="sub-title">{{ $t('propTrade.createAccount.payment.subscriptionDetails') }}</h5>
            <div>
              <div class="detail">
                <div class="detail-text">
                  {{ $t('propTrade.createAccount.subscriptionDetail.item') }}
                </div>
                <div class="join_line"></div>
                <p class="detail-text">
                  {{ chooseAccountData.currentSetting.fee | fixedDecimal(2) }} {{ chooseAccountData.form.currency }}
                </p>
              </div>
              <ul class="detail-list">
                <li>
                  <span class="label">{{ $t('propTrade.createAccount.subscriptionDetail.accountType') }} :</span>
                  <span class="value">{{
                    $t(`propTrade.accountType.${ACCOUNT_TYPE_REV[chooseAccountData.form.accountType]}`)
                  }}</span>
                </li>
                <li>
                  <span class="label">{{ $t('propTrade.createAccount.subscriptionDetail.accountBalance') }} :</span>
                  <span class="value"
                    >{{ new Intl.NumberFormat().format(chooseAccountData.form.accountBalance) }}
                    {{ chooseAccountData.form.currency }}</span
                  >
                </li>
                <li>
                  <span class="label">{{ $t('propTrade.createAccount.subscriptionDetail.targetProfit') }} :</span>
                  <span class="value">{{ chooseAccountData.form.tradingPlatform }}</span>
                </li>
              </ul>
            </div>

            <div class="promo-code">
              <p class="promo-code-label">{{ $t('propTrade.createAccount.subscriptionDetail.promoCode') }}</p>
              <el-form-item prop="promoCode">
                <div class="promo-code-form">
                  <div class="input-box">
                    <TextInput
                      type="text"
                      :customClasses="`promo-code-input  ${promoCodeStatus} ${lang}`"
                      v-model.trim="promoCode"
                      dataTestId="promoCode"
                      suffix-icon="icon-check"
                      :disabled="promo.lastSuccesss.status"
                      :placeholder="$t('propTrade.createAccount.subscriptionDetail.promoCode')"
                    />
                    <div class="error-message" v-if="promoCodeStatus === 'error'">
                      {{ promoErrorMessage }}
                    </div>
                  </div>
                  <el-button
                    class="promo-code-button"
                    :disabled="promo.lastSuccesss.status || !isPromoCodeTyped"
                    data-testid="apply"
                    @click="applyPromoCodeHandler(currentSettingId)"
                    >{{ $t('propTrade.button.apply') }}</el-button
                  >
                </div>
              </el-form-item>
            </div>
            <ul class="fee">
              <li>
                <div class="label">
                  <span>{{ $t('propTrade.createAccount.payment.subtotal') }}</span>
                </div>
                <div class="join_line"></div>
                <div class="value">
                  <span>{{ chooseAccountData.currentSetting.fee | fixedDecimal(2) }}</span>
                  <span class="currency">{{ chooseAccountData.form.currency }}</span>
                </div>
              </li>
              <li v-show="promo.lastSuccesss.status && discount">
                <div class="label">
                  <span>{{ $t('propTrade.createAccount.payment.discount') }}</span>
                </div>
                <div class="join_line"></div>
                <div class="value">
                  <span class="currency">-{{ discount | fixedDecimal(2) }}</span>
                  <span>{{ chooseAccountData.form.currency }}</span>
                </div>
              </li>
              <li>
                <div class="label total">
                  <span>{{ $t('propTrade.createAccount.payment.grandSubscriptionFee') }}</span>
                  <InfoPopover popoverWidth="220">
                    <template v-slot:popoverContent>
                      {{ $t('propTrade.createAccount.payment.totalSubscriptionFeeInfo') }}
                    </template>
                  </InfoPopover>
                </div>
                <div class="value total">
                  <span>{{ finalFee | fixedDecimal(2) }}</span>
                  <span class="currency">{{ chooseAccountData.form.currency }}</span>
                  <span v-if="form.paymentMethod === 'thailandqr'"
                    >({{ exchangeRate | fixedDecimal(2) }}&nbsp;THB)</span
                  >

                  <p v-if="form.paymentMethod === 'thailandqr'" class="exchange_rate">
                    {{
                      $t('deposit.default.rate.rate', {
                        oldCurrency: 'USD',
                        newCurrency: 'THB'
                      })
                    }}
                    <span>{{ rate }}</span>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="btn-box">
          <div class="back-button">
            <el-button type="primary" :class="'action-button'" data-testId="back" @click="goBackToChooseAccount">{{
              $t('propTrade.button.back')
            }}</el-button>
          </div>
          <div class="confirm-button">
            <CryptoQrCodeBtn
              v-if="form.paymentMethod === 'crypto'"
              :amount="finalFee"
              :accountCurrency="chooseAccountData.form.currency"
              :class="'action-button'"
              @submitForm="submit('form')"
            ></CryptoQrCodeBtn>
            <el-button
              v-else
              type="primary"
              class="blue_button action-button"
              data-testId="confirm"
              @click="submit('form')"
              >{{ $t('propTrade.button.subscribe') }}
            </el-button>
          </div>
        </div>
      </el-form>
    </div>
    <InfoDialog
      :visible.sync="showConfirmDialog"
      type="warning"
      :enableCloseOnBackground="true"
      :append-to-body="false"
      :subTitle="$t('propTrade.createAccount.subscriptionDetail.waitAMoment')"
    >
      <div slot="content">
        <div>{{ $t('propTrade.createAccount.subscriptionDetail.cancelPromoCodeInfo') }}</div>
        <div class="button-wrapper">
          <el-button class="white_button" @click="showConfirmDialog = false">{{
            $t('propTrade.button.cancel')
          }}</el-button>
          <el-button class="blue_button" type="primary" @click="handleHasPromoCodeGoBack">{{
            $t('propTrade.button.yes')
          }}</el-button>
        </div>
      </div>
    </InfoDialog>
    <div v-html="bankHTML"></div>
  </div>
</template>

<script>
import {
  apiPropTradingProceedPayment,
  apiPropTradingProceedPaymentCPS,
  apiCheckPromoAvailable
} from '@/resource/propTrading';
import propTradeCommonFilters from '@/mixins/page/propTrade/commonFilters';
import mixin from '@/mixins';
import DepositMixin from '@/mixins/deposit';
import cpsDepositListingMixin from '@/mixins/cpsDepositListing';
import cpsMixin from '@/mixins/cpsDeposit';
import {
  ACCOUNT_TYPE_REV,
  PROMO_CODE_DISCOUNT_ALL_PRICE,
  PROMO_CODE_TYPE,
  PERMITTED_CPS_CRYPTO_PAYMENT_METHODS,
  PERMITTED_CPS_EWALLET_PAYMENT_METHODS,
  PERMITTED_CPS_LBT_PAYMENT_METHODS
} from '@/constants/propTrade';
import { isSuccess } from '@/util/utils';
import {insightechTrack} from "@/util/insightechTracking";
import PaymentMethodRadioButton from '@/components/propTrading/components/createAccount/PaymentMethodRadioButton.vue';
import TextInput from '../common/TextInput.vue';
import InfoPopover from '@/components/propTrading/components/common/InfoPopover.vue';
import InfoDialog from '../common/InfoDialog.vue';
import CryptoQrCodeBtn from '@/components/deposit/QrCode/QrCodeButton.vue';
import isMobile from '@/mixins/isMobile';
import { apiExchangeRate } from '@/resource';

export default {
  name: 'SubscriptionDetail',
  mixins: [mixin, DepositMixin, cpsMixin, propTradeCommonFilters, cpsDepositListingMixin, isMobile],
  components: { PaymentMethodRadioButton, TextInput, InfoPopover, InfoDialog, CryptoQrCodeBtn },
  props: {
    chooseAccountData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      ACCOUNT_TYPE_REV,
      form: {
        paymentMethod: 'crypto',
        crypto: null,
        ewallet: null
      },
      formRules: {
        paymentMethod: [
          {
            required: true,
            message: this.$t('common.formValidation.dynamicReq', {
              dynamic: this.$t('propTrade.createAccount.subscriptionDetail.subTitle')
            }),
            trigger: 'change'
          }
        ]
      },
      paymentDetail: {},
      promoCodeStatus: '',
      promoErrorMessage: '',
      promoCode: '',
      promo: {
        lastSuccesss: {
          code: '',
          status: false,
          result: null
        }
      },
      bankHTML: '',
      showConfirmDialog: false,
      rate: 1
    };
  },
  computed: {
    lang() {
      return this.$store.state.common.lang;
    },
    calPaymentMethodList() {
      const paymentMethodList = [
        {
          name: this.$t('propTrade.createAccount.subscriptionDetail.creditcard'),
          key: 'creditcard'
        },
        {
          name: this.$t('propTrade.createAccount.subscriptionDetail.crypto'),
          key: 'crypto'
        }
      ];

      if (this.displayEwalletList) {
        paymentMethodList.push({
          name: this.$t('propTrade.createAccount.subscriptionDetail.ewallet'),
          key: 'ewallet'
        });
      }
      if (this.displayLbtList) {
        paymentMethodList.push({
          name: this.$t('withdraw.default.localBankTransfer'),
          key: 'thailandqr'
        });
      }
      return paymentMethodList;
    },
    isPromoCodeTyped() {
      return !(this.promoCode.length === 0);
    },
    currentSettingId() {
      return this.chooseAccountData.currentSetting?.id;
    },
    propTradingCpsDeposit() {
      return this.cpsDepositList.reduce((acc, cur) => {
        if (cur?.child && cur.child.length > 0) {
          cur.child.forEach(obj => {
            acc.push(obj);
          });
          return acc;
        }
      }, []);
    },
    customFilterCpsDepositList() {
      let paymentCodeList = ['T00400', 'T00600_062'];
      console.log('3_propTradingCpsDeposit', this.propTradingCpsDeposit)
      return this.propTradingCpsDeposit.filter(payment => {
        if (!payment?.merchant_variable?.enable_pt) return false;
        const uniqueCurrency = payment.unique_currency;

        if (uniqueCurrency?.length) {
          return uniqueCurrency.map(i => i.currency_code).includes(this.chooseAccountData.currentSetting?.currency);
        }
        return (
          payment?.merchant_variable?.enable_pt &&
          (this.chooseAccountData.currentSetting?.currency === payment.currency_code ||
            paymentCodeList.includes(payment.payment_method))
        );
      });
    },
    cryptoList() {
      console.log('5_customFilterCpsDepositList', this.customFilterCpsDepositList)
      const cryptoList = this.customFilterCpsDepositList.filter(payment =>
        PERMITTED_CPS_CRYPTO_PAYMENT_METHODS.includes(payment.payment_method)
      );

      if (!this.form.crypto && cryptoList.length > 0) {
        const payment = cryptoList[0];

        this.form.crypto = payment.merchant_variable?.label || payment.merchant_variable?.description_title;

        this.changePaymentDetail(payment);
      }

      return cryptoList;
    },
    ewalletList() {
      return this.customFilterCpsDepositList.filter(payment =>
        PERMITTED_CPS_EWALLET_PAYMENT_METHODS.includes(payment.payment_method)
      );
    },
    thailandqrList() {
      console.log(
        384,
        this.customFilterCpsDepositList.filter(payment =>
          PERMITTED_CPS_LBT_PAYMENT_METHODS.includes(payment.payment_method)
        )
      );
      return this.customFilterCpsDepositList.filter(payment =>
        PERMITTED_CPS_LBT_PAYMENT_METHODS.includes(payment.payment_method)
      );
    },
    displayEwalletList() {
      return !!this.ewalletList.length;
    },
    displayLbtList() {
      console.log(390, this.thailandqrList);
      return !!this.thailandqrList.length;
    },
    discount() {
      if (this.promo.lastSuccesss.result) {
        return this.calcDiscount(this.promo.lastSuccesss.result, this.chooseAccountData.currentSetting.fee);
      }
      return 0;
    },
    finalFee() {
      const res = Number(this.chooseAccountData.currentSetting.fee) - Number(this.discount);
      return res > 0 ? res : 0;
    },
    exchangeRate() {
      return this.rate * this.finalFee;
    },
    proceedPaymentRequestBody() {
      return {
        feeId: this.currentSettingId,
        leverage: this.chooseAccountData.form.leverage,
        code: this.promo.lastSuccesss.code
      };
    },
    paymentDetails() {
      return this.$store.state.cps.payment;
    },
    isNewPtClient() {
      return this.$store.state.propTrading.isPropTradingAccount;
    }
  },
  watch: {
    ['promoCode']() {
      if (this.promo.lastSuccesss.status) {
        if (this.promoCode === this.promo.lastSuccesss.code) {
          this.promoCodeStatus = 'success';
        } else {
          this.promoCodeStatus = null;
        }
      }
    },
    'form.paymentMethod': {
      handler(val) {
        if (val === 'thailandqr') {
          this.getExchangeRate();
        }
      }
    }
  },
  methods: {
    getExchangeRate() {
      apiExchangeRate({ fromCurrency: this.chooseAccountData.form.currency, toCurrency: 'THB' })
        .then(res => {
          if (res.data.code == 0) {
            this.rate = res.data.data;
          }
        })
        .catch(err => console.log(err));
    },
    goToDestination() {
      this.$router.push({ name: 'home' });
    },
    getPaymentName(payment) {
      const name =
        payment.merchant_variable?.label_pt ||
        payment.merchant_variable?.label ||
        payment.merchant_variable?.description_title;
      return this.langTranslate('deposit.cpsInfo.', name);
    },
    goBackToChooseAccount() {
      if (this.promo.lastSuccesss.status) {
        this.showConfirmDialog = true;
      } else {
        this.$emit('redirectCurrentPage', 'chooseAccount');
      }
    },
    handleHasPromoCodeGoBack() {
      this.showConfirmDialog = false;
      this.$emit('redirectCurrentPage', 'chooseAccount');
    },
    async proceedPaymentCPS() {
      // refactor: extract to utils(or other place)
      const determineActualCurrencyCode = currency => {
        return currency === 'USC' ? 'USD' : currency;
      };

      // refactor: extract to utils(or other place)
      const getCurrencyNumber = (item, currency) => {
        if (item.unique_currency && currency) {
          const uniqueCurrencyConfig = item.unique_currency;
          let configObject = {};
          uniqueCurrencyConfig.forEach(config => {
            if (config.actual_currency_code === currency) {
              configObject = { ...config };
            }
          });
          return configObject.currency_number;
        }
        return item.currency_number;
      };

      //   // refactor: extract to utils(or other place)
      const getActualCurrencyNumber = (item, currency) => {
        if (item.unique_currency && currency) {
          const uniqueCurrencyConfig = item.unique_currency;
          let configObject = {};
          uniqueCurrencyConfig.forEach(config => {
            if (config.actual_currency_code === currency) {
              configObject = { ...config };
            }
          });
          return configObject.actual_currency_number;
        }
        return item.actual_currency_number;
      };

      try {
        const attachVariableObj = {};

        const attachVariables = this.paymentDetails.attach_variable
          ? this.paymentDetails.attach_variable.filter(f => f.length > 0)?.[0]
          : '';

        if (attachVariables) {
          attachVariables.map(a => {
            attachVariableObj[a.key] = a.value;
          });
        }

        const requestBody = {
          cpsCode: this.paymentDetails.payment_method,
          orderCurrency: this.paymentDetails.unique_currency
            ? getCurrencyNumber(this.paymentDetails, determineActualCurrencyCode(this.chooseAccountData.form.currency))
            : this.paymentDetails.currency_number,
          actualCurrency: this.paymentDetails.unique_currency
            ? getActualCurrencyNumber(
                this.paymentDetails,
                determineActualCurrencyCode(this.chooseAccountData.form.currency)
              )
            : this.paymentDetails.actual_currency_number,
          mandatory: this.paymentDetails.attach_variable
            ? this.paymentDetails.attach_variable.filter(f => f.length > 0)?.[0].toString()
            : '',
          attachVariables: JSON.stringify(attachVariableObj),
          ...this.proceedPaymentRequestBody
        };

        const result = await apiPropTradingProceedPaymentCPS(requestBody, this.token);

        return result;
      } catch (e) {
        console.error(e);
      }

      return null;
    },
    async proceedPayment() {
      try {
        const result = await apiPropTradingProceedPayment(this.proceedPaymentRequestBody, this.token);
        return result;
      } catch (e) {
        console.error(e);
      }
    },
    async proceedPaymentSuccessResultHandle(result) {
      const data = result?.data?.data;
      if (data && data === PROMO_CODE_DISCOUNT_ALL_PRICE) {
        await this.$store.dispatch('propTrading/actionGetEligiblePropTrading');

        this.$router.push({ name: 'propTradingDashboard' });

        return true;
      }

      return false;
    },
    submit(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (!this.promoCodeCheck()) {
            return;
          }
          // Tracking code
          insightechTrack('ptclient', this.isNewPtClient ? 'newsubpt' : 'exisitingsubpt');

          if (this.form.paymentMethod === 'creditcard') {
            const result = await this.proceedPayment();

            if (isSuccess(result.data)) {
              const isHandled = await this.proceedPaymentSuccessResultHandle(result);

              if (isHandled) return;

              const data = result.data.data;

              if (data) {
                this.$emit('redirectCurrentPage', 'subscriptionCreditCard', data);
              }
            }
          } else {
            const result = await this.proceedPaymentCPS();
            const isHandled = await this.proceedPaymentSuccessResultHandle(result);
            if (isHandled) return;
            if (this.form.paymentMethod === 'crypto') this.goToCryptoQrcode(result);
            else this.cpsHandling(result);
          }
        }
      });
    },
    changePaymentDetail(data) {
      // this.paymentDetail = data;
      this.$store.dispatch('cps/actionSetPayment', data);
    },
    setPaymentDetailDefault(value) {
      if (!['crypto', 'ewallet', 'thailandqr'].includes(value)) return;
      this.form[value] =
        this[`${value}List`][0].merchant_variable?.label_pt ||
        this[`${value}List`][0].merchant_variable?.label ||
        this[`${value}List`][0].merchant_variable?.description_title;
      this.changePaymentDetail(this[`${value}List`][0]);
    },
    applyPromoCodeHandler() {
      this.applyPromoCode(this.currentSettingId);
    },
    async applyPromoCode(feeSettingId = '') {
      const result = await apiCheckPromoAvailable(feeSettingId, this.promoCode);

      if (isSuccess(result.data)) {
        this.promoCodeStatus = 'success';
        this.promoErrorMessage = '';
        this.promo.lastSuccesss.status = true;
        this.promo.lastSuccesss.code = this.promoCode;
        this.promo.lastSuccesss.result = result.data.data;

        return result.data.data;
      } else {
        this.promoCodeStatus = 'error';
        this.promoErrorMessage = this.$t(
          result?.data?.code ? `responseMsg.${result.data.code}` : 'propTrade.promoCode.unknownError'
        );
        this.promo.lastSuccesss.status = false;
        this.promo.lastSuccesss.code = '';
        this.promo.lastSuccesss.result = null;
        this.promoCode = '';

        return null;
      }
    },
    calcDiscount(promo, fee = 0) {
      if (promo.promoType === PROMO_CODE_TYPE.RATE) {
        return fee * (promo.offPercentage / 100);
      } else if (promo.promoType === PROMO_CODE_TYPE.AMOUNT) {
        return promo.offAmount;
      }

      return 0;
    },
    promoCodeCheck() {
      if (!this.promo.lastSuccesss.status && this.promoCode) {
        this.promoCodeStatus = 'error';
        this.promoErrorMessage = this.$t('propTrade.promoCode.applyFirst');
        return false;
      }
      return true;
    },
    cpsHandling(result) {
      let channelData = JSON.parse(result.data.data);
      if (result.data.code == 0 && result.data.data) {
        this.bankHTML = channelData.payment_content;

        if (this.bankHTML) {
          this.redirectHandling();
        } else {
          this.errorMessage(this.$t('deposit.default.failed'));
        }
      } else {
        if (result.data.code !== 562) {
          this.errorMessage(this.$t('deposit.default.failed'));
        }
      }
    },
    redirectHandling() {
      this.$nextTick(function () {
        if (document.getElementById('paysubmit') != null) {
          if (document.getElementById('paysubmit')) {
            document.getElementById('paysubmit').submit();
          } else {
            this.errorMessage(this.$t('deposit.default.failed'));
          }
        }
      });
    },
    goToCryptoQrcode(result) {
      if (result.data.code == 0 && result.data.data) {
        const channelData = JSON.parse(result.data.data);
        if (channelData.deposit_crypto_address !== '') {
          const data = {
            cryptoAddress: channelData.deposit_crypto_address,
            actualAmount: channelData.actual_amount,
            actualCurrencyCode: this.paymentDetails.actual_currency_code
          };
          this.$emit('redirectCurrentPage', 'cryptoQrcode', data);
        } else {
          console.log('showErrorMsg');
        }
      }
    }
  },
  mounted() {
    // get cps deposit channels list
    this.getCPSDepositChannels();
  }
};
</script>
<style lang="scss" scoped>
.title-box,
.form-box {
  .sub-title {
    color: $primary-dark-blue;
    font-weight: 700;
    line-height: 20px;
    padding-bottom: 10px;
    font-size: 16px;
  }
}
.title-box {
  margin-bottom: 32px;
}
.narrative {
  color: #323232;
  font-size: 12px;
  line-height: 17px;
}
.divide {
  margin-bottom: 30px;
}
.exchange_rate {
  color: #6e6e73;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}
.payment_desc_start {
  align-items: self-start !important;
}
.payment_desc {
  padding: 10px 20px;
  border-radius: 8px;
  background: rgba(226, 88, 39, 0.08);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  .payment_text {
    color: #716e73;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
}
.payment-method {
  display: flex;
  > .el-form-item {
    width: 100%;
    margin-bottom: 8px;
  }
  .payment-method-radio-box {
    display: flex;
    gap: 0 16px;
    .payment-method-item {
      flex: 1;
      margin-bottom: 20px;
      max-width: 370px;
      flex-basis: unset;
      .el-radio-group {
        width: 100%;
      }
      /deep/ .el-radio-button {
        width: 100%;
        .el-radio-button__inner {
          width: 100%;
          border-radius: 59px;
          height: 40px;
          line-height: 1;
        }
        &:last-child {
          @include rtl-sass-prop(margin-right, margin-left, 0);
        }
      }
    }
  }
}

.payment-method-group .payment-radio {
  /deep/ .el-radio-group {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    gap: 0 40px;
  }
  /deep/ .el-radio {
    margin-bottom: 10px;
    color: $primary-dark-blue;
    font-size: 14px;
    font-weight: 600;
  }
  /deep/ .el-radio__label {
    @include rtl-sass-prop(padding-left, padding-right, 10px);
  }
  /deep/ .el-radio__input.is-checked + .el-radio__label {
    color: $primary-dark-blue;
  }
}
.grey-card {
  background-color: #0051ff08;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 40px;
  .sub-title {
    color: $primary-dark-blue;
    font-weight: 700;
  }
  .detail {
    display: flex;
    justify-content: space-between;
    &-text {
      margin-bottom: 8px;
      color: #323232;
      font-weight: 400;
      font-size: 14px;
    }
    .join_line {
      flex: 1;
      margin: 0 10px;
      border: 0.5px dashed #b2b2b2;
      opacity: 0.5;
      height: 0;
      position: relative;
      top: 9px;
    }
  }
  .detail-list {
    margin-bottom: 8px;
    li {
      font-size: 14px;
      color: #323232;
      line-height: 21px;
    }
    .label {
      display: inline-block;
      margin-right: 4px;
    }
  }

  .promo-code {
    margin: 32px 0;
    &-form {
      display: flex;
    }
    &-label {
      color: $primary-dark-blue;
      font-weight: 700;
      flex-basis: unset;
      margin-bottom: 12px;
      font-size: 16px;
    }
    &-input {
      width: 300px;
      padding: 0 !important;
      @include rtl-sass-prop(margin-right, margin-left, 10px);
      &.success {
        [dir='ltr'] * /deep/ .el-input__inner {
          padding-right: 32px;
        }
        [dir='rtl'] * /deep/ .el-input__inner {
          padding-left: 32px;
        }
        /deep/.icon-check {
          &::before {
            display: inline-block;
          }
        }
      }
      /deep/.icon-check {
        &::before {
          content: '';
          background: url(~@/assets/images/propTrade/check.png) no-repeat center;
          background-size: cover;
          width: 19px;
          height: 19px;
          display: none;
          top: 4px;
          right: 4px;
          left: auto;
          position: relative;
        }
      }
    }
    &-button {
      font-size: 14px;
      font-weight: 700;
      padding: 9px 20px;
      width: 120px;
      height: 38px;
      border-radius: 35px;
      background: #fff;
      color: $primary-dark-blue;
      border-color: $primary-dark-blue;
      &.el-button.is-disabled {
        background: #f4f4f4;
        color: #949494;
        border-color: #f4f4f4;
      }
    }
    .error-message {
      font-size: 12px;
      line-height: 1;
      padding-top: 4px;
      position: absolute;
      top: 100%;
      color: #f44040;
    }
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .fee {
    margin-top: 12px;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      line-height: 21px;
      font-weight: 400;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .label {
      font-size: 14px;
      color: $primary-dark-blue;
      &.total {
        font-size: 16px;
        font-weight: 700;
        line-height: 22px;
        flex-basis: 50%;
      }
    }
    .join_line {
      flex: 1;
      margin: 0 10px;
      border: 0.5px dashed #b2b2b2;
      opacity: 0.5;
    }
    .value {
      font-size: 14px;
      color: $primary-dark-blue;
      text-align: right;
      &.total {
        font-size: 34px;
        font-weight: 700;
        line-height: 34px;
      }
    }
  }
}
.btn-box {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  flex-wrap: no-wrap;
  .action-button {
    padding: 8px 12px;
    min-width: 200px;
    font-weight: 600;
    width: 100%;
    line-height: normal;
    border-radius: 59px;
    height: 40px;
  }
  .back-button .action-button {
    border: 1px solid $primary-blue;
    color: $primary-blue;
    background-color: $white;
    border-radius: 35px;
    height: 40px;
  }
}
hr {
  border-style: dashed;
  border-color: $stone-gray;
}
/deep/ .el-dialog__wrapper {
  .el-dialog {
    width: 460px !important;
  }
}

@media (max-width: 768px) {
  /deep/.card {
    padding: 20px 21px;
  }
  .title-box,
  .form-box {
    font-size: 14px;
  }
  .title-box {
    margin-bottom: 16px;
  }
  .payment-method {
    .payment-method-radio-box {
      gap: 0 16px;
      flex-wrap: wrap;
      .payment-method-item {
        max-width: 140px;
        /deep/ .el-radio-button {
          width: 100%;
          .el-radio-button__inner {
            height: 32px;
            line-height: 4px;
          }
        }
      }
    }
  }
  .grey-card {
    margin-bottom: 12px;
    .detail {
      &-text {
        font-size: 12px;
      }
      .join_line {
        top: 7px;
      }
    }
    .detail-list {
      margin-bottom: 8px;
      li {
        font-size: 12px;
      }
    }
    .promo-code {
      margin: 20px 0;
      &-form {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .input-box {
          width: 100%;
        }
      }
      &-label {
        font-size: 14px;
      }
      &-input {
        width: auto;
        margin-bottom: 20px;
        @include rtl-sass-prop(margin-right, margin-left, 0);
      }
      &-button {
        width: 100%;
        height: auto;
      }
    }
    .fee {
      .label {
        font-size: 12px;
        &.total {
          font-size: 14px;
          font-weight: 600;
          line-height: 17px;
        }
      }
      .value {
        font-size: 12px;
        &.total {
          font-size: 16px;
          line-height: 22px;
        }
      }
    }
  }
  .btn-box {
    gap: 16px;
    .action-button {
      min-width: 140px;
      font-size: 12px;
    }
  }
  /deep/ .el-dialog__wrapper {
    .el-dialog {
      width: 340px !important;
    }
    .el-dialog__body {
      padding: 0 15px 40px !important;
    }
  }
}
@media (max-width: 550px) {
  .blue_button,
  .white_button {
    margin-bottom: 0 !important;
  }
}
</style>
